import { useEffect, useState } from "react";
import { Switch, useHistory } from "react-router";
import { NavLink, Route } from "react-router-dom";
import { Dropdown, Header, Label, List, Menu, MenuItemProps, Segment } from "semantic-ui-react";
import { logout, useCurrentUser, useLocal } from "../hooks/auth-hook";
import { useModalControl } from "../hooks/commonHooks";
import { restRequest } from "../http";
import { RouteWithSubRoutes } from "../routes";
import { ChangePassword } from "./ChangePasswordComponent";
import { DashboardComponent } from "./DashboardComponent";
import { DropdownOption } from "../models/testing_model";
import { TestingDataMenu } from "./commons/TestingDataMenu";
import { LanguageContext } from "../context";

export function Home(props: { routes: any[] }) {
    const history = useHistory();
    const currentUser = useCurrentUser();
    const changePasswordModalControl = useModalControl();
    const currentUrl = history.location.pathname.trim();
    const local = useLocal(currentUser.language);

    return (<LanguageContext.Provider value={local}><div style={{ padding: '1rem' }}>
        <Menu pointing>
            <Menu.Item
                icon="home"
                active={history.location.pathname === '/'}
                onClick={e => {
                    e.preventDefault();

                    history.push('/');
                }}
            />

            {currentUser.availablePages.filter(category => category.name && category.pages.length > 0).map(category => {
                const currentPage = category.pages.find(p => currentUrl.length > 1 && p.url.startsWith(currentUrl));
                return <Menu.Item style={{ padding: 0 }} active={!!currentPage} key={category.name}>
                    <Dropdown item text={category.name + (currentPage ? `: ${currentPage.name}` : '')}>
                        <Dropdown.Menu>
                            {category.pages.map(p => <Dropdown.Item as={NavLink} to={p.url} key={category.name + p.url}>{p.name}</Dropdown.Item>)}
                        </Dropdown.Menu>
                    </Dropdown>
                </Menu.Item>
            })}

            {currentUser.availablePages.filter(category => !category.name && category.pages.length > 0).map((category, index) => category.pages.map(p => <Menu.Item key={index + p.url}
                name={p.name}
                as={NavLink} to={category.name + p.url}
            />)
            )}

            {currentUser.permissions.testing.view && <TestingDataMenu />}

            <Menu.Menu position='right'>
                <Dropdown item text={`Hello ${currentUser.name}`}>
                    <Dropdown.Menu>
                        <Dropdown.Item onClick={e => {
                            changePasswordModalControl.setOpen(true);
                        }}>Change Password</Dropdown.Item>
                        <Dropdown.Item onClick={e => {
                            logout().then(() => {
                                history.push('/login');
                            })
                        }}>Logout</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </Menu.Menu>
        </Menu>
        <Switch>
            {props.routes.map((route: any, i: any) => (
                <RouteWithSubRoutes key={i} {...route} />
            ))}

            <Route path="*" component={DashboardComponent}></Route>
        </Switch>

        <ChangePassword modelControl={changePasswordModalControl} onFinish={result => {
            if (result) {
                changePasswordModalControl.setOpen(false);

                //force user to login again
                restRequest<any>('auth/login', null, 'get');
            }
        }}></ChangePassword>
    </div ></LanguageContext.Provider>)
}

